import { sliderToggle } from "../common/sliderFunctions.js";

document
    .querySelectorAll(".ns-blog-regular-text__slider-button")
    .forEach((item) => {
        item.addEventListener("click", function (e) {
            if (e.currentTarget.classList.contains("opened")) {
                e.currentTarget.classList.remove("opened");
            } else {
                e.currentTarget.classList.add("opened");
            }

            sliderToggle(e.currentTarget.nextElementSibling, 500);
        });
    });
